import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Steven, { ELEMENT_TYPES } from 'helpers/steven';
import { ActionLink } from 'components/shared';
import { useModal } from 'components/shared/hooks';
import Common from 'helpers/intl-common';
import useCreateIntegrationActionRequest from './useCreateIntegrationActionRequest';
import IntegrationIcon from './IntegrationIcon';

import { LD_INTEGRATIONS_NEW_QBO_MODAL } from 'constants/featureFlags';
import { useFlags } from 'launchdarkly-react-client-sdk';

const IntegrationActionLink = ({
  integrationAction,
  projectNodeId,
  projectDatabaseId,
  requestArgs,
}) => {
  const intl = useIntl();
  const { showModal, hideModal, Modal } = useModal();

  const flags = useFlags();
  const isNewQBOModalEnabled = flags[LD_INTEGRATIONS_NEW_QBO_MODAL];

  const { createIntegrationActionRequest } = useCreateIntegrationActionRequest({
    integrationActionId: integrationAction.id,
    projectId: projectNodeId,
    requestArgs: JSON.stringify(requestArgs || {}),
  });

  const showConfirmationModal = () => {
    Steven.elementClicked({
      id: 'action_menu_integration_action_link',
      content: `${integrationAction.name}`,
      type: ELEMENT_TYPES.BUTTON,
      action: 'action_link_request_sent',
    });

    if (isNewQBOModalEnabled) {
      showModal(Modal.SEND_TO_QUICKBOOKS, {
        onRequestClose: hideModal,
        title: integrationAction.name,
        destructive: false,
        projectDatabaseId,
        projectNodeId,
        integrationActionId: integrationAction.id,
        requestArgs,
      });
    } else {
      showModal(Modal.CONFIRMATION, {
        onRequestClose: hideModal,
        confirmAction: () => {
          createIntegrationActionRequest();
          hideModal();
        },
        confirmLabel: intl.formatMessage(Common.confirm),
        cancelLabel: intl.formatMessage(Common.cancel),
        message: integrationAction.description,
        title: integrationAction.name,
        destructive: false,
      });
    }
  };

  return (
    <ActionLink
      className="dropdown-menu__link"
      onClick={showConfirmationModal}
      data-testid={`projects__actions__${integrationAction.name}`}
    >
      <IntegrationIcon
        integrationPackage={integrationAction.integrationPackage}
      />
      {integrationAction.name}
    </ActionLink>
  );
};

IntegrationActionLink.propTypes = {
  integrationAction: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    integrationPackage: PropTypes.shape({
      name: PropTypes.string.isRequired,
      logoUrl: PropTypes.string,
      iconUrl: PropTypes.string,
    }),
  }).isRequired,
  projectNodeId: PropTypes.string.isRequired,
  projectDatabaseId: PropTypes.number,
  requestArgs: PropTypes.shape({
    photo_ids: PropTypes.arrayOf(PropTypes.number),
  }),
};

export default IntegrationActionLink;
